// src/theme/colors.ts
export const colors = {
  primary: '#179246',
  accent: '#58BA59',
  neutral: '#686868',
  black: '#000',
  white: '#fff',
};
